// Utility to update sitemap when blogs are created/deleted
import { SITE_CONFIG } from '../config';
import { getBlogModifiedDateIso, isBlogPublished } from './blogPublishDate';

export const updateSitemap = async () => {
  try {
    // Fetch all blogs
    const blogsResponse = await fetch(`https://tophamtechbe.com/api/treas/blogs/v1/get-blog?site_id=${SITE_CONFIG.SITE_ID}`, {
      headers: { 'X-API-Key': 'treas-api-key-2025' }
    });
    
    const blogs = blogsResponse.ok ? await blogsResponse.json() : [];
    const publishedBlogs = Array.isArray(blogs) ? blogs.filter(isBlogPublished) : [];
    // Always the apex domain from config — never window.location.origin: publishing
    // a blog while browsed on www.<domain> would regenerate the whole sitemap with
    // www URLs while canonicals say apex, and Google stops indexing.
    const domain = `https://${SITE_CONFIG.BASE_URL.replace(/^https?:\/\//, '').replace(/^www\./, '')}`;
    const today = new Date().toISOString();
    
    // Generate sitemap XML with actual routes
    let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${domain}/</loc>
    <lastmod>${today}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>${domain}/blogs</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/reviews</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/agent</loc>
    <lastmod>${today}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/contact-us</loc>
    <lastmod>${today}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/flint</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/grand-blanc</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/davison</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/burton</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/swartz-creek</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/neighborhood/oakland-county</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>`;

    // Add SEO landing pages
    const seoSlugs = [
      'homes-for-sale-flint-mi', 'flint-mi-real-estate-agent', 'buy-a-home-in-flint-michigan',
      'sell-my-house-flint-mi', 'first-time-home-buyer-flint', 'flint-mi-investment-properties',
      'genesee-county-real-estate', 'flint-mi-home-values', 'houses-for-rent-flint-mi',
      'flint-michigan-neighborhoods', 'fenton-mi-homes-for-sale', 'burton-mi-real-estate',
      'swartz-creek-homes-for-sale', 'clio-mi-real-estate', 'flushing-mi-homes-for-sale',
      'linden-mi-real-estate', 'flint-mi-foreclosures', 'flint-mi-open-houses',
      'relocating-to-flint-michigan', 'flint-mi-luxury-homes'
    ];
    seoSlugs.forEach(slug => {
      sitemap += `
  <url>
    <loc>${domain}/${slug}</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>`;
    });

    // Add blog posts
    if (publishedBlogs.length) {
      publishedBlogs.forEach(blog => {
        const slug = blog.title.toLowerCase()
          .replace(/[^a-z0-9 -]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .trim('-');
        const lastmod = getBlogModifiedDateIso(blog) || today;
        sitemap += `
  <url>
    <loc>${domain}/blog/${slug}</loc>
    <lastmod>${lastmod}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.6</priority>
  </url>`;
      });
    }

    sitemap += `
</urlset>`;

    // Send to backend to update sitemap file
    const formData = new FormData();
    const xmlBlob = new Blob([sitemap], { type: 'text/xml' });
    formData.append('xml', xmlBlob, 'sitemap.xml');
    formData.append('site_id', SITE_CONFIG.SITE_ID);
    
    await fetch('https://tophamtechbe.com/api/treas/ads/v1/set-xml', {
      method: 'POST',
      headers: {
        'X-API-Key': 'treas-api-key-2025'
      },
      body: formData
    });
    
  } catch (error) {
    console.error('Error updating sitemap:', error);
  }
};